export const AddToCartSuccess = ({
  className = '',
}: {
  onClick?: ((value: string) => void) | null
  className?: string
}) => {
  return (
    <svg
      className={className}
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 34L26 42L46 22'
        stroke='#219653'
        strokeWidth='4'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M32 61C48.0163 61 61 48.0163 61 32C61 15.9837 48.0163 3 32 3C15.9837 3 3 15.9837 3 32C3 48.0163 15.9837 61 32 61Z'
        stroke='#219653'
        strokeWidth='4'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}
